import { styled } from "@mui/material";

const ActionsWrapper = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}))

export default ActionsWrapper